export default class ElementTransitions {
    constructor({ $elems = [], removeClassAfterAnimation = false, threshold }) {
        this.$elems = $elems;

        this.removeClassAfterAnimation = removeClassAfterAnimation;
        this.threshold = threshold;

        if (this.$elems.length) {
            this.init();
        }
    }

    init() {
        const mediaLaptop = window.matchMedia('(max-width: 1024px)').matches;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animated');
                    observer.unobserve(entry.target);

                    if (this.removeClassAfterAnimation) {
                        function handleAnimationEnd(event) {
                            event.stopPropagation();
                            setTimeout(() => {
                                entry.target.classList.remove('animate', 'animated');
                            }, 500);
                        }

                        entry.target.addEventListener('animationend', handleAnimationEnd, {once: true});
                    }
                }
            });
        }, {
            threshold: this.threshold ? this.threshold : mediaLaptop ? 0.4 : 0.65
        });

        this.$elems.forEach(($section) => {
            observer.observe($section);
        });
    }
}